import {
  Box,
  Center,
  HStack,
  Heading,
  Icon,
  Image,
  Radio,
} from '@hover/blueprint';
import type { BoxProps } from '@hover/blueprint/chakra';
import { iconImages } from '@hover/icons';
import React from 'react';

import { CobrandLogo } from 'src/modules/homeownerApp/components/CobrandLogo';
import type { PublicOrgInfo } from 'src/shared/graphql/generated';

interface ProjectSelectionCardProps extends Omit<BoxProps, 'id'> {
  id: string | number;
  isSelected?: boolean;
  onClick: () => void;
  imageSrc?: string;
  label: string;
  org?: PublicOrgInfo | null;
}

export const PROJECT_CARD_HEIGHT = '262px';
export const PROJECT_CARD_WIDTH = '253px';
const IMAGE_HEIGHT = '190px';

const ProjectSelectionCard = ({
  id,
  isSelected,
  onClick,
  imageSrc,
  label,
  org,
  ...props
}: ProjectSelectionCardProps) => (
  <Box
    alignItems="flex-start"
    borderRadius={400}
    cursor="pointer"
    flexDir="column"
    gap={0}
    height={PROJECT_CARD_HEIGHT}
    minW={PROJECT_CARD_WIDTH}
    onClick={onClick}
    overflow="hidden"
    shadow={{ base: 'distance300', tablet: 'distance400' }}
    width={PROJECT_CARD_WIDTH}
    {...props}
  >
    {imageSrc ? (
      <Image
        alt={`project-${id}`}
        height={IMAGE_HEIGHT}
        minH={IMAGE_HEIGHT}
        objectFit="cover"
        src={imageSrc}
        transition="filter 0.2s ease-in-out"
        width="100%"
      />
    ) : (
      <Center
        backgroundColor="neutral.50"
        height={IMAGE_HEIGHT}
        minH={IMAGE_HEIGHT}
        onClick={onClick}
        width="100%"
      >
        <Icon color="neutral.500" icon={iconImages} size="medium" />
      </Center>
    )}
    <Box alignItems="center" gap={200} h="100%" px="400">
      <Radio isChecked={isSelected} size="large" variant="filled" />
      <HStack gap={200} justifyContent="space-between">
        <Box>
          <Heading
            m="0!important"
            p="0!important"
            textOverflow="ellipsis"
            textStyle="headingXs"
          >
            {label}
          </Heading>
        </Box>
        {org && (
          <CobrandLogo
            cobrandId={org?.id}
            cobrandLogo={org?.brandLogoUrl ?? undefined}
            cobrandName={org?.displayName}
            hideHoverMark
            justifyContent="flex-end"
            width="auto"
          />
        )}
      </HStack>
    </Box>
  </Box>
);

export { ProjectSelectionCard };
